import React from "react";
import { Input } from "@/components/ui/input";
import { Info } from "lucide-react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";

export const NumberField = ({ label, unit, value, onChange, testId, step = "any", prefix, hint }) => {
  return (
    <div className="space-y-1.5">
      <div className="flex items-center gap-1.5">
        <label className="font-mono-label text-[11px] uppercase tracking-wider text-muted-foreground block">
          {label}
        </label>
        {hint && (
          <Tooltip delayDuration={100}>
            <TooltipTrigger asChild>
              <button
                type="button"
                aria-label={`What is ${label}?`}
                data-testid={testId ? `${testId}-hint` : undefined}
                className="text-muted-foreground/60 hover:text-primary transition-colors"
              >
                <Info className="h-3.5 w-3.5" />
              </button>
            </TooltipTrigger>
            <TooltipContent side="top" className="max-w-[240px] text-xs leading-relaxed">
              {hint}
            </TooltipContent>
          </Tooltip>
        )}
      </div>
      <div className="relative">
        {prefix && (
          <span className="absolute left-3 top-1/2 -translate-y-1/2 text-sm text-muted-foreground pointer-events-none">
            {prefix}
          </span>
        )}
        <Input
          type="number"
          inputMode="decimal"
          step={step}
          min="0"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          data-testid={testId}
          className={`h-11 rounded-lg font-medium tabular-nums ${prefix ? "pl-7" : ""} ${unit ? "pr-14" : ""}`}
        />
        {unit && (
          <span className="absolute right-3 top-1/2 -translate-y-1/2 text-xs font-mono-label text-muted-foreground pointer-events-none">
            {unit}
          </span>
        )}
      </div>
    </div>
  );
};
